import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import StudyInJapan from '../components/Services/StudyInJapan';
import VisaServices from '../components/Services/VisaServices';
import CareerSupport from '../components/Services/CareerSupport';
import JLPTPreparation from '../components/Services/JLPTPreparation';
import SpecialCourses from '../components/Services/SpecialCourses';
import StudyMaterials from '../components/Services/StudyMaterials';

const Services: React.FC = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <div className="relative">
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        {/* Background Elements */}
        <div className="absolute inset-0">
          {/* Gradient Background */}
          <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-white to-secondary/10"></div>
          
          {/* Animated Circles */}
          <div className="absolute top-0 -left-4 w-72 h-72 bg-primary/20 rounded-full mix-blend-multiply filter blur-xl animate-blob"></div>
          <div className="absolute top-0 -right-4 w-72 h-72 bg-secondary/20 rounded-full mix-blend-multiply filter blur-xl animate-blob animation-delay-2000"></div>
          <div className="absolute -bottom-8 left-20 w-72 h-72 bg-primary/20 rounded-full mix-blend-multiply filter blur-xl animate-blob animation-delay-4000"></div>
          
          {/* Animated Grid Pattern */}
          <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 px-4">
          <motion.div
            ref={ref}
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <motion.h1 
              className="text-6xl md:text-8xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-primary to-secondary"
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              Our Services
            </motion.h1>
            <motion.p 
              className="text-2xl md:text-3xl text-gray-700 max-w-4xl mx-auto mb-12"
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              Comprehensive support for your journey to study and work in Japan
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.6 }}
              className="flex flex-wrap justify-center gap-6"
            >
              <button className="px-10 py-4 bg-primary text-white rounded-full hover:bg-primary/90 transition-colors duration-300 shadow-lg hover:shadow-xl text-lg">
                Get Started
              </button>
              <button className="px-10 py-4 bg-white text-primary border-2 border-primary rounded-full hover:bg-primary/10 transition-colors duration-300 shadow-lg hover:shadow-xl text-lg">
                Learn More
              </button>
            </motion.div>
          </motion.div>

          {/* Scroll Indicator */}
          {/* <motion.div
            className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
            animate={{
              y: [0, 10, 0],
            }}
            transition={{
              duration: 1.5,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          >
            <div className="w-6 h-10 border-2 border-primary rounded-full p-1">
              <div className="w-1.5 h-1.5 bg-primary rounded-full mx-auto"></div>
            </div>
          </motion.div> */}
        </div>
      </section>

      {/* Service Components */}
      <StudyInJapan />
      <VisaServices />
      <JLPTPreparation />
      <CareerSupport />
      <SpecialCourses />
      <StudyMaterials />
    </div>
  );
};

export default Services; 